<template>
  <div class="container">
    <!-- 操作按钮区域 -->
    <a-row :gutter="[20, 20]">
      <a-col :span="24">
        <div class="table-operator">
          <a-button @click="handleAdd" type="primary" icon="plus" ghost style="margin-right: 10px">
            新增
          </a-button>
          <a-button
            @click="batchDel"
            :disabled="selectedRowKeys.length <= 0"
            ghost
            type="primary"
            icon="delete"
          >
            批量删除
          </a-button>
        </div>
      </a-col>
    </a-row>
    <a-row>
      <a-col :span="24">
        <TableList
          rowKey="id"
          bordered
          :loading="loading"
          :columns="columns"
          :tableData="dataSource"
          :scroll="false"
          :pagination="ipagination"
          @change="handleTableChange"
          :rowSelection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        >
          <div slot="action" slot-scope="{ record }" style="cursor: pointer">
            <a @click="handleEdit(record)">编辑</a>
            <a-divider type="vertical" />
            <a-popconfirm title="确定删除吗?" @confirm="() => handleDelete(record.id)">
              <a>删除</a>
            </a-popconfirm>
            <a-divider type="vertical" />
            <a-popconfirm title="确定推送文章吗?" @confirm="() => notification(record)">
              <a>推送</a>
            </a-popconfirm>
          </div>
        </TableList>
      </a-col>
    </a-row>
    <RichTextModal ref="modalForm" @ok="modalFormOk" @updateTable="updateTable" />
  </div>
</template>
<script>
import TableList from '@/components/chart/TableList'
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import RichTextModal from './modules/RichTextModal'
import { getAction } from '@api/manage'

export default {
  name: 'DataReport',
  components: { TableList, RichTextModal },
  mixins: [JeecgListMixin],
  data() {
    return {
      columns: [
        {
          title: '标题',
          dataIndex: 'title',
          align: 'center',
        },
        {
          title: '内容',
          dataIndex: 'content',
          align: 'center',
          customRender: (_, record) => {
            return record.content.length >= 70
              ? record.content.substring(0, 70) + '...'
              : record.content
          },
        },
        {
          title: '操作',
          dataIndex: 'action',
          align: 'center',
          scopedSlots: { customRender: 'action' },
        },
      ],
      tableData: [],
      url: {
        list: '/dataReport/list',
        deleteBatch: '/dataReport/deleteBatch',
        delete: '/dataReport/delete',
      },
    }
  },
  methods: {
    updateTable() {
      this.loadData()
    },
    notification(record) {
      getAction('/ddUser/parentDingMessage', {
        userId: '02503962506836284993',
        urlDing: `pagesA/pages/DataReport/index?id=${record.id}`,
        text: '测试',
      }).then((res) => {
        if (res.success) {
          this.$message.success('文章推送成功')
          return true
        }
        this.$message.error('文章推送失败')
      })
      //   getAction('/ddUser/getParentIds', {
      //     studentId: this.studentInfo.studentId,
      //     urlDing: 'pagesA/pages/Home/h-rector/detail?role=4&corpId=',
      //     text: '# 爱心小叮当  \\n  ' + this.content,
      //   }).then((res) => {
      //     if (res.success) {
      //       this.$message.success('消息推送成功')
      //     }
      //   })
    },
  },
}
</script>

<style lang="less" scoped>
.container {
  background-color: #fff;
  padding: 20px;
  min-height: 70vh;
}
</style>
